export var TypeActionNotEnoughResource;
(function (TypeActionNotEnoughResource) {
    TypeActionNotEnoughResource["BuyWithGold"] = "NotEnoughResource > BuyWithGold";
    TypeActionNotEnoughResource["BuyWithGoldConfirmed"] = "NotEnoughResource > BuyWithGoldConfirmed";
    TypeActionNotEnoughResource["BuyWithGoldComplete"] = "NotEnoughResource > BuyWithGoldComplete";
    TypeActionNotEnoughResource["Cancel"] = "NotEnoughResource > Cancel";
})(TypeActionNotEnoughResource || (TypeActionNotEnoughResource = {}));
export var actionNotEnoughResourceBuyWithGold = function (missingResources) { return ({
    isPurchased: false,
    missingResources: missingResources,
    type: TypeActionNotEnoughResource.BuyWithGold,
}); };
export var actionNotEnoughResourceBuyWithGoldConfirm = function (missingResources) { return ({
    isPurchased: false,
    missingResources: missingResources,
    type: TypeActionNotEnoughResource.BuyWithGoldConfirmed,
}); };
export var actionNotEnoughResourceCancel = function () { return ({
    type: TypeActionNotEnoughResource.Cancel,
}); };
export var actionNotEnoughResourceBuyWithGoldComplete = function (isPurchased) {
    if (isPurchased === void 0) { isPurchased = false; }
    return ({
        isPurchased: isPurchased,
        type: TypeActionNotEnoughResource.BuyWithGoldComplete,
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/not-enough-resource/actionNotEnoughResource.ts
// module id = 163
// module chunks = 3